import Collapse from 'antd/es/collapse';
import Table from 'antd/es/table';
import styled from 'styled-components';

import { Discount } from '@components/ui/labels/discount/DiscountLabelStyle';
import Modal from '@components/Modal';

export const StyledModal = styled(Modal)`
  .setur-modal-body {
    @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
      overflow-y: auto;
      height: calc(100vh - 200px);
    }
  }

  .setur-modal-header {
    position: relative;

    @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
      height: initial;
    }
  }

  .setur-modal-close {
    width: 100%;
    border-bottom: 1px solid ${({ theme }) => theme.palette.lightBlueGrey};
    position: absolute;
    top: 0;
    right: 0;
    height: auto;

    @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
      display: flex;
    }
  }

  .setur-modal-close-x {
    @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
      display: flex;
      width: 100%;
      position: initial;
      padding: 20px 11px;
      justify-content: space-between;
    }
  }

  .setur-collapse-expand-icon {
    @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
      position: absolute;
      top: 30px;
      right: 15px;
    }
  }
`;

export const MobileModalTitle = styled.div`
  flex: 1;
  color: red;
  justify-self: center;
  align-self: center;
  font-size: 14px;
  font-weight: 600;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: ${({ theme }) => theme.palette.darkGrey};
`;

export const Header = styled.div`
  font-size: 30px;
  line-height: normal;
  font-weight: 900;
  color: ${({ theme }) => theme.palette.darkGrey};
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    font-size: 20px;
  }
`;

export const SubHeader = styled.div`
  font-size: 24px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.darkGrey};
  margin-top: 20px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    margin-top: 0;
    font-size: 14px;
    line-height: normal;
  }
`;

export const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-row-gap: 20px;
`;

export const OptionsWrapper = styled.div`
  display: grid;
  grid-template-columns: 317px 317px;
  grid-column-gap: 20px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    grid-template-columns: 1fr;
    grid-row-gap: 15px;
  }
`;

export const StyledTable = styled(Table)`
  .dark-bg {
    background-color: ${({ theme }) => theme.palette.lynxWhite};
  }

  thead[class*='setur-table-thead'] th {
    background-color: white !important;
    text-align: center;
    font-size: 18px;
    font-weight: bold;
    color: ${({ theme }) => theme.palette.darkGrey};
  }
`;

export const CurrentPeriodIndicator = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 4px;
  background-color: ${({ theme }) => theme.palette.clearBlue};
`;

export const CurrentPeriodText = styled.span`
  font-size: 12px;
  font-weight: 600;
  opacity: 0.8;
  color: ${({ theme }) => theme.palette.darkGrey};
  margin-left: 5px;
`;

export const DateRangeBoardTypeText = styled.div`
  font-size: 16px;
  font-weight: bold;
  line-height: normal;
  color: ${({ theme }) => theme.palette.primaryBrand};

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    font-size: 12px;
  }
`;

export const ShowDetailsText = styled.div`
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  cursor: pointer;
  color: ${({ theme }) => theme.palette.darkGrey};
`;

export const WarningMessageContainer = styled.span`
  padding: 12px 15px;
  border-radius: 2px;
  background-color: rgba(27, 117, 226, 0.1);
  display: flex;
  align-items: center;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    padding: 14px 19px 11px 6px;
  }
`;

export const WarningMessageText = styled.span`
  font-size: 14px;
  color: ${({ theme }) => theme.palette.clearBlue};
  margin-left: 12px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    margin-left: 6px;
    font-size: 12px;
    font-weight: 600;
    line-height: normal;
    text-align: justify;
  }
`;

export const DiscountWrapper = styled(Discount)`
  font-size: 11.6px;
  align-items: center;
  justify-content: center;
  align-self: flex-end;
  line-height: normal;
  width: 110px;
`;

export const InfoIconWrapper = styled.div`
  align-self: flex-start;
`;

export const StyledCollapse = styled(Collapse)`
  .setur-collapse-item > .setur-collapse-header {
    padding: 16px 6px 11px 11px !important;
  }
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    .anticon {
      padding: 10px 0px 50px 0px !important;
    }
  }
`;

export const StyledCollapsePanel = styled(Collapse.Panel)`
  background-color: ${({ theme }) => theme.palette.lynxWhite};
  padding: 0;

  .setur-collapse-content-box {
    padding: 0px;
  }

  .setur-collapse-header > span {
    top: 22px !important;
    right: 15px !important;
  }

  .setur-collapse-header {
    padding-right: 11px !important;
  }
`;

export const WeekDaysText = styled.div`
  margin-right: 5px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    opacity: 0.8;
    font-size: 12px;
    color: ${({ theme }) => theme.palette.darkGrey};
  }
`;

export const WeekDayDiscountWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 7px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    margin-top: 5px;
  }
`;

export const GuestInfoWrapper = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.palette.gray87};
`;
